import Select from 'react-select';

import styles from './styles.module.css';

const Dropdown: typeof Select = props => {
  return <Select className={styles.container} classNamePrefix="react-select" {...props} />;
};

export default Dropdown;
